import { render } from "./TrainingResourceCategoryComponent.vue?vue&type=template&id=dc2471b4&scoped=true"
import script from "./TrainingResourceCategoryComponent.vue?vue&type=script&lang=js"
export * from "./TrainingResourceCategoryComponent.vue?vue&type=script&lang=js"

import "./TrainingResourceCategoryComponent.vue?vue&type=style&index=0&id=dc2471b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2471b4"]])

export default __exports__